import { Service } from '@core/models/Service';
import { Consent } from '@core/models/Consent';
import { Client } from '@state/clients/client.model';
import { FLOW_TIME_FORMAT } from '@core/constants';
import moment from 'moment';
import { Pack } from '@core/models/Pack';
import { Cabinet } from '@core/models/Cabinet';

export interface Agenda {
    id: string;
    cabinetCode: string;
    date: moment.Moment;
    start: moment.Moment;
    end: moment.Moment;
    blockAgenda: boolean;
    blockedId: string;
    laserGid: string;
    client: Partial<Client>;
    color: string;
    professionalCabinets: Cabinet[];
    professionalName: string;
    professionalId: string;
    cabinetNumber: string;
    cabinetAbbr: string;
    comments: string;
    blockedComments?: string;
    migrated: boolean;
    delayed: boolean;
    notAttended: boolean;
    fwa: boolean;
    equipConfirm: boolean;
    listConsents: Consent[];
    listServices: Service[];
    listPacks: Pack[];
    signedConsents: boolean;
    tags: string[];
    multiAppointmentId: number;
    multiAppointments: any;
    otherUser: boolean;
    ticketGClosed: boolean;
    userAvConfirm: boolean;
    userEaConfirm: boolean;
    userOvConfirm: boolean;
    userSkConfirm: boolean;
    confirmTag: string;
    canNotAssistedApp: boolean;
    doctorValidated: boolean;
    confirmed: string;
    hasDoubleVisual: boolean;
    partialValidated: boolean;
}

export const createAgenda = (data: any): Agenda => {
    // Create services list from treatmentList or d32 (just service name) to show service names in graphic agenda.
    let listServices: Service[];
    let treatmentList = [];
    if(data.d32 === ''){
        if(data.treatmentList && data.treatmentList !== ''){
            treatmentList = JSON.parse(data.treatmentList.replace(/"/g, '\\\\\'\\\\\'').replace(/\\\\'/g,'&apos;').replace(/'/g, '"').replace(/&apos;/g,'\''));
        }else{
            treatmentList = data.d11.split(',');
        }
        listServices = treatmentList.map(serviceName => ({
            fromPack: '0',
            id: '',
            group: '',
            name: serviceName,
            familyName: '',
            familyId: 0,
            isTreatment: true,
            slots: 1,
            time: moment.duration('1', 'm'),
            voucherId: '',
            price: 0
        }));
    }else{
        const diaryList = JSON.parse(data.d32.replace(/"/g, '\\\\\'\\\\\'').replace(/\\\\'/g,'&apos;').replace(/'/g, '"').replace(/&apos;/g,'\''));
        listServices = [];
        diaryList.forEach((diary) => {
            diary.treatments.forEach(serviceName => {
                listServices.push({
                    fromPack: '0',
                    id: '',
                    group: '',
                    familyName: '',
                    familyId: 0,
                    name: serviceName,
                    isTreatment: true,
                    slots: 1,
                    time: moment.duration('1', 'm'),
                    voucherId: '',
                    price: 0
                });
            });
        });
    }

    const appointmentDateEnd = moment(`${data.d3}|${data.d5}`, `MM/DD/YYYY|${FLOW_TIME_FORMAT}`);
    let color = data.d13;
    // If appointment is before current date and is not validated, use danger color
    if (moment().isAfter(appointmentDateEnd) && data.d7 === '0') {
        color = getComputedStyle(document.documentElement).getPropertyValue('--ion-color-danger').trim();
    }

    return ({
        id: (data.d1 === '0' && data.d22 == '-1')
            ? `unavailable-${data.d2}-${data.d4}-${data.d5}` 
            : data.d1,
        cabinetCode: data.d2,
        cabinetAbbr: data.CabinetAbbr,
        date: moment(data.d3, 'MM/DD/YYYY'),
        start: moment(data.d4, FLOW_TIME_FORMAT),
        end: moment(data.d5, FLOW_TIME_FORMAT),
        laserGid: data.d7,
        blockAgenda: data.d8 === '-1',
        blockedId: data.d26,
        blockedComments: data.d23,
        client: {
            deferred: data.d34 !== '0',
            id: data.d20,
            name: data.d9,
            number: data.d28,
            temporal: data.d27 !== '0',
            vouchers: data.d12 // Cuando se implementen los bonos cambiar esto por un array de objetos voucher.
        },
        fwa: data.d16 === '-1',
        professionalCabinets: [],
        professionalName: data.d14,
        color,
        tags: data.d29.split('|').filter(tagId => tagId !== ''),
        multiAppointmentId: parseInt(data.d31, 10),
        // eslint-disable-next-line max-len, @typescript-eslint/quotes
        multiAppointments: data.d32 !== '' ? JSON.parse(data.d32.replace(/"/g, "\\\\'\\\\'").replace(/\\\\'/g,'&apos;').replace(/'/g, '"').replace(/&apos;/g,"\'")) : [],
        migrated: data.d21 === '-1',
        delayed: data.d17 === '-1',
        notAttended: data.d18 === '-1',
        otherUser: data.d22 === '-1',
        listServices,
        listPacks: [],
        doctorValidated: data.doctorconfirm === '-1',
        partialValidated: data.d33 !== '' && parseInt(data.d33, 10) > 0 && parseInt(data.d33, 10) < 100
    } as Agenda);
};
